import React, { useMemo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useTitleStyles } from './styles';

export const Title = ({ roleCount }) => {
  const classes = useTitleStyles();

  const values = useMemo(
    () => ({
      count: roleCount,
      strong: chunks => <strong>{chunks}</strong>
    }),
    [roleCount]
  );

  return (
    <Grid
      container
      spacing={0}
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography className={classes.title} variant="body2">
        <FormattedMessage
          id="advancedRateCard.notReferencedProjectRoles.title"
          values={values}
        />
      </Typography>
    </Grid>
  );
};

Title.propTypes = {
  roleCount: PropTypes.number
};
